import React from 'react';
import { useContent } from '../i18n/LanguageContext';
import { Radio, Check, PenLine, CalendarDays } from 'lucide-react';

export default function TechGuide() {
  const c = useContent();
  const g = c.guide;

  return (
    <section id="guide" className="py-16 md:py-24 bg-slate-50" data-testid="tech-guide">
      <div className="lt-container">
        <div className="max-w-3xl reveal">
          <p className="text-sm font-semibold uppercase tracking-widest text-teal-600">{g.eyebrow}</p>
          <h2 className="mt-3 font-display text-3xl md:text-4xl font-bold text-slate-900 leading-tight">{g.title}</h2>
          <p className="mt-4 text-lg text-slate-600">{g.subtitle}</p>
          <div className="mt-5 flex flex-wrap items-center gap-x-6 gap-y-2 text-sm text-slate-500" data-testid="guide-byline">
            <span className="inline-flex items-center gap-1.5"><PenLine className="w-4 h-4 text-teal-600" />{g.byline}</span>
            <span className="inline-flex items-center gap-1.5"><CalendarDays className="w-4 h-4 text-teal-600" />{g.updated}</span>
          </div>
        </div>

        <div className="mt-10 reveal overflow-x-auto rounded-3xl border border-slate-200 bg-white shadow-sm">
          <table className="w-full text-left border-collapse min-w-[640px]">
            <thead>
              <tr className="border-b border-slate-200">
                {g.cols.map((col, i) => (
                  <th key={i} data-testid={`guide-col-${i}`}
                    className={`px-5 py-4 text-sm font-semibold ${i === 1 ? 'text-teal-700 bg-teal-50' : 'text-slate-700'}`}>
                    <span className="inline-flex items-center gap-1.5">{i === 1 && <Radio className="w-4 h-4" />}{col}</span>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {g.rows.map((row, ri) => (
                <tr key={ri} className="border-b border-slate-100 last:border-0">
                  {row.map((cell, ci) => (
                    <td key={ci} className={`px-5 py-3.5 text-sm ${ci === 0 ? 'font-medium text-slate-700' : ci === 1 ? 'text-teal-800 bg-teal-50/60 font-medium' : 'text-slate-500'}`}>{cell}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="mt-8 reveal rounded-2xl bg-slate-900 text-white p-6 md:p-7 flex items-start gap-4 max-w-3xl" data-testid="guide-takeaway">
          <span className="grid place-items-center w-10 h-10 rounded-xl bg-teal-500/20 text-teal-300 shrink-0"><Check className="w-5 h-5" /></span>
          <div>
            <p className="font-display font-bold text-teal-300">{g.takeawayTitle}</p>
            <p className="mt-1 text-slate-200">{g.takeaway}</p>
          </div>
        </div>
      </div>
    </section>
  );
}
